export default __webpack_public_path__ + "static/media/private.b14650d1.jpg";